import { Text, View } from "@react-pdf/renderer";
import { parseDate } from "helpers/date";

import { styles } from "../styles";

export function PatientInfoCustom({
  name,
  dateOfBirth,
  today,
  expirationDate,
}: {
  name: string;
  dateOfBirth: string;
  today: string;
  expirationDate: string;
}) {
  return (
    <View
      style={{
        marginTop: 0,
        marginBottom: 0,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingLeft: 50,
        paddingRight: 10,
      }}
    >
      <View
        style={{
          display: "flex",
          marginBottom: "8px",
          flexDirection: "column",
        }}
      >
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text style={{ ...styles.listTitle, width: 75, fontSize: "10px" }}>
            Patient:
          </Text>
          <Text style={{ fontSize: "10px" }}>{name}</Text>
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text style={{ ...styles.listTitle, width: 75, fontSize: "10px" }}>
            Date of Birth:
          </Text>
          <Text style={{ fontSize: "10px" }}>{parseDate(dateOfBirth)}</Text>
        </View>
      </View>
      <View style={styles.dateWrapper}>
        <View style={styles.dateContainer}>
          <Text style={styles.dateTitle}>PREPARED DATE</Text>
          <Text style={styles.dateText}>{today}</Text>
        </View>
        <View style={styles.dateContainer}>
          <Text style={styles.dateTitle}>EXPIRATION DATE</Text>
          <Text style={styles.dateText}>{expirationDate}</Text>
        </View>
      </View>
    </View>
  );
}
